import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { IconUserHeart, IconMessageQuestion } from "@tabler/icons-react";

export function InsightLayout() {
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const isAsk = pathname.startsWith("/insights/ask");

	return (
		<div style={{ display: "grid", gap: "0.75rem" }}>
			<div
				style={{
					display: "flex",
					gap: "0.35rem",
					padding: 2,
					borderRadius: "var(--radius-full)",
					background: "var(--color-surface-2)",
				}}
			>
				<button
					type="button"
					onClick={() => navigate("/insights")}
					style={{
						flex: 1,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: "0.35rem",
						padding: "0.55rem 0",
						borderRadius: "var(--radius-full)",
						border: "none",
						cursor: "pointer",
						fontSize: "0.82rem",
						fontWeight: 600,
						transition: "all 200ms ease",
						background: !isAsk ? "var(--color-primary)" : "transparent",
						color: !isAsk ? "#fff" : "var(--color-muted)",
						boxShadow: !isAsk
							? "0 1px 3px rgba(0,0,0,0.08)"
							: "none",
					}}
				>
					<IconUserHeart size={14} /> Profil
				</button>
				<button
					type="button"
					onClick={() => navigate("/insights/ask")}
					style={{
						flex: 1,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						gap: "0.35rem",
						padding: "0.55rem 0",
						borderRadius: "var(--radius-full)",
						border: "none",
						cursor: "pointer",
						fontSize: "0.82rem",
						fontWeight: 600,
						transition: "all 200ms ease",
						background: isAsk ? "var(--color-primary)" : "transparent",
						color: isAsk ? "#fff" : "var(--color-muted)",
						boxShadow: isAsk
							? "0 1px 3px rgba(0,0,0,0.08)"
							: "none",
					}}
				>
					<IconMessageQuestion size={14} /> Tanya
				</button>
			</div>
			<Outlet />
		</div>
	);
}
